function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.997 511.997",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF5B62"
    },
    cx: 255.999,
    cy: 255.999,
    r: 255.999
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FED298"
    },
    d: "M85.421,166.503l85.319,42.406c0,0,62.95-20.373,72.748-17.188c0.952,0.309,2.56,0.947,4.669,1.833 l0.008,0.005c19.555,8.236,82.871,38.477,82.871,38.477l-18.047-1.152c7.342,9.43,17.567,21.773,23.376,25.372 c9.781,6.056-13.512,23.292-33.071,10.712c-19.563-12.577-24.688-27.948-24.688-27.948l-9.674,0.999l67.847,62.304l10.778,12.919 c9.325,11.177-2.254,27.321-17.483,22.4c0.243,0.184-0.619-0.068-0.391,0.551c0.871,2.345,2.631,7.976,1.044,10.723 c-5.576,9.666-13.973,17.104-31.76,3.557c4.31,3.282,6.951,11.006,3.961,15.497c-4.068,6.112-8.553,8.869-13.459,10.364 c-5.17,1.576-12.966-3.365-17.27-6.644c4.307,3.279,6.359,11.058,3.488,15.638c-3.533,5.637-14.757,13.921-21.873,8.498 l-22.358-17.028c0,0-54.424-52.699-71.24-66.724c-16.821-14.031-39.681-42.577-39.681-42.577l-100.524-55.78l65.415-47.217 L85.421,166.503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0F7986"
    },
    d: "M0.936,234.181l73.591,49.184l77.778-102.116L58.69,92.886 C26.384,131.93,5.445,180.714,0.934,234.181H0.936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M150.235,183.965l-65.552,86.06l12.566,9.574l65.552-86.063L150.235,183.965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0BA7D"
    },
    d: "M426.579,166.503l-85.319,42.406c-6.82,3.389-31.324-12.666-51.484-15.113 c-14.597-1.771-32.232,3.89-31.182,4.435l45.703,21.126c0,0,22.279,30.847,32.061,36.898c9.781,6.054-13.512,23.292-33.071,10.712 c-19.563-12.577-24.688-27.948-24.688-27.948l-40.436,4.168l-77.958,68.891c-10.791,9.537-7.491,14.514-0.234,23.816 c3.318,4.26,15.513,2.825,20.625,0.871c-11.806,8.981,5.217,32.111,21.907,19.389c-10.093,7.691,4.383,34.807,24.596,19.405 c-10.083,13.592,10.468,23.478,19.109,21.021l6.259-1.779l-1.598-1.217c-0.517,0-16.887-16.787-17.878-18.823 c-5.6-11.494,9.157-27.059,22.387-15.93l11.387,8.743l-6.597-8.365c-8.415-11.027-1.938-22.413,6.122-25.865 c5.907-2.526,12.021,0.28,17.005,5.196l12.577,10.077l-10.715-12.52c0,0-10.277-11.609-0.844-21.976 c9.433-10.364,22.216,2.062,22.216,2.062l15.046,12.439l-12.95-14.999c0,0-11.216-11.791-3.667-19.68 c10.486-10.959,23.46-0.166,33.703,10.628c2.943,3.103,5.975,7.869,8.276,10.069c11.305-12.724,18.912-26.516,18.912-26.516 l126.146-74.412l-65.413-47.217L426.579,166.503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD24D"
    },
    d: "M511.063,234.179l-73.594,49.187L359.695,181.25l93.615-88.364 c32.308,39.041,53.242,87.826,57.756,141.293H511.063z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M361.759,183.965l65.557,86.06l-12.569,9.574l-65.549-86.063L361.759,183.965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M67.369,256.189c2.573,0,4.661,2.088,4.661,4.661c0,2.573-2.085,4.661-4.661,4.661 c-2.573,0-4.661-2.085-4.661-4.661C62.708,258.277,64.793,256.189,67.369,256.189z M53.504,247.501c2.573,0,4.661,2.085,4.661,4.661 c0,2.573-2.088,4.661-4.661,4.661c-2.573,0-4.661-2.088-4.661-4.661C48.843,249.589,50.928,247.501,53.504,247.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M447.447,258.717c-2.573,0-4.661,2.088-4.661,4.661s2.085,4.661,4.661,4.661 c2.573,0,4.661-2.085,4.661-4.661C452.108,260.805,450.023,258.717,447.447,258.717z M461.312,250.03 c-2.573,0-4.661,2.085-4.661,4.661c0,2.573,2.088,4.661,4.661,4.661c2.573,0,4.661-2.088,4.661-4.661S463.888,250.03,461.312,250.03 z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellIcon);
export default __webpack_public_path__ + "static/media/sell_icon.18a7d2ab06a740a2db8c6b22e843003b.svg";
export { ForwardRef as ReactComponent };